import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';
interface IAsteriskIconProps extends IConDefaultType {}

function AsteriskIcon({ className, size = 24, rotate, flip, color }: IAsteriskIconProps) {
  const theme = useTheme();

  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
          d="M8.06504 13.5463C7.52833 13.5463 7.25998 13.3451 7.25998 12.9425V9.34853L4.15475 11.1312C3.98223 11.227 3.80972 11.2462 3.63721 11.1887C3.48386 11.1312 3.3401 10.9874 3.20593 10.7574C2.93757 10.2973 2.98549 9.96191 3.34969 9.75106L6.45492 7.93967L3.34969 6.15704C3.19634 6.0612 3.1005 5.92702 3.06217 5.75451C3.02383 5.582 3.07175 5.38073 3.20593 5.15072C3.3401 4.90153 3.48386 4.74819 3.63721 4.69068C3.80972 4.63318 3.98223 4.65235 4.15475 4.74819L7.25998 6.55957V2.9368C7.25998 2.76429 7.32707 2.62053 7.46124 2.50552C7.59542 2.39051 7.79668 2.33301 8.06504 2.33301C8.58258 2.33301 8.84135 2.53427 8.84135 2.9368V6.55957L11.9753 4.74819C12.1287 4.65235 12.2916 4.63318 12.4641 4.69068C12.6366 4.74819 12.79 4.90153 12.9241 5.15072C13.1925 5.59158 13.1446 5.92702 12.7804 6.15704L9.67516 7.93967L12.7804 9.75106C12.9337 9.82773 13.0296 9.95232 13.0679 10.1248C13.1254 10.2973 13.0775 10.5082 12.9241 10.7574C12.79 10.9874 12.6366 11.1312 12.4641 11.1887C12.2916 11.2462 12.1287 11.227 11.9753 11.1312L8.84135 9.31978V12.9425C8.84135 13.3451 8.58258 13.5463 8.06504 13.5463Z"
          fill={color || theme.color.icon.icon_3}
        />
      </svg>
    </i>
  );
}

export default AsteriskIcon;
